import React from 'react'
import { TableCell, TableRow } from '@/components/ui/table'
import { StatusBadge } from '@/components'
import Amount from '../../Amount'
import TransactionsTableSkeleton from '../../../home-page/transactions-table.skeleton'
import { format } from 'date-fns'
import PropTypes from 'prop-types'
import { convertUTCToET } from '@/utils/date-format-util'

const PendingTransactionsRows = ({ data }) => {
  const renderTableRows = () => {
    return data?.map((transaction, index) => {
      return (
        <React.Fragment key={transaction?.id + index}>
          <TableRow data-testid="transaction-table-row">
            <TableCell className="font-normal text-sm text-neutral-700 md:table-cell hidden italic ">
              <div className="flex items-center ">
                <span>{format(new Date(convertUTCToET(transaction.node?.createdAt)), 'MMM dd, yyyy') ?? '-'}</span>
              </div>
            </TableCell>
            <TableCell className="flex flex-row items-center w-[200px] max-[374px]:w-auto text-sm font-medium text-neutral-900 px-0 md:px-4 md:hidden">
              <div className="flex flex-col">
                {transaction?.node.source && Object.keys(transaction.node.source).length > 0 ? (
                  <div className="text-sm font-medium leading-5 text-neutral-900">
                    {transaction?.node?.source?.transactionEvents?.[0]?.merchantDetails?.name}
                  </div>
                ) : (
                  <div className="flex items-center text-sm font-medium text-neutral-900">Payment - Thank You</div>
                )}
                <span className="text-neutral-700 font-normal text-sm leading-5">
                  {format(new Date(convertUTCToET(transaction.node?.createdAt)), 'MMM dd, yyyy')}
                </span>
              </div>
            </TableCell>
            <TableCell className="hidden md:table-cell">
              <div className="flex items-center italic">
                <StatusBadge status={'pending'} />
              </div>
            </TableCell>
            <TableCell className="font-medium text-sm hidden text-neutral-900 md:table-cell">
              {transaction?.node.source && Object.keys(transaction.node.source).length > 0 ? (
                <div className="flex items-center italic">
                  {transaction?.node?.source?.transactionEvents[0]?.merchantDetails?.name}
                </div>
              ) : (
                <div className="flex items-center italic">Payment - Thank You</div>
              )}
            </TableCell>
            <TableCell className="hidden md:table-cell"></TableCell>
            <TableCell>
              <div className="flex flex-col justify-center md:items-start items-end">
                <Amount
                  amount={transaction?.node.pendingAmount.value}
                  sign={transaction?.node?.sign === 'NEGATIVE' ? null : transaction?.node?.sign}
                  customColor={
                    transaction?.node.source && Object.keys(transaction.node.source).length > 0
                      ? 'text-neutral-700'
                      : 'text-success-600'
                  }
                />
                <div className="md:hidden">
                  <StatusBadge status={'pending'} />
                </div>
              </div>
            </TableCell>
          </TableRow>
        </React.Fragment>
      )
    })
  }

  return !data ? <TransactionsTableSkeleton /> : data?.length > 0 && renderTableRows()
}

export default PendingTransactionsRows

PendingTransactionsRows.propTypes = {
  data: PropTypes.array,
  page: PropTypes.string,
}
